import { useState } from 'react';

export function CopyableValue({ label, value, className = '' }) {
  const [copied, setCopied] = useState(false);

  if (!value) {
    return null;
  }

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard may be blocked outside secure context.
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? 'Copied' : `Click to copy ${label}`}
      className={[
        'inline rounded px-0.5 font-inherit text-inherit transition',
        'cursor-pointer hover:bg-slate-200/80 hover:text-slate-800',
        copied ? 'text-emerald-700' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label ? `${label} ` : ''}
      {value}
      {copied ? ' · copied' : ''}
    </button>
  );
}
